import { render, staticRenderFns } from "./Comprometimentos2.vue?vue&type=template&id=ac719a66&"
import script from "./Comprometimentos2.vue?vue&type=script&lang=js&"
export * from "./Comprometimentos2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports